import { LockOutlined as LockOutlinedIcon } from '@mui/icons-material';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/authService';

export default function Login({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showApprovalDialog, setShowApprovalDialog] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    // Tally script yükleme
    if (!document.querySelector('script[src="https://tally.so/widgets/embed.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const success = await login(credentials.email, credentials.password);
      if (success) {
        // Login başarılı - State'i güncelle
        if (setIsAuthenticated) {
          setIsAuthenticated(true);
        }
        // Login fonksiyonu 2 saniye sonra sayfayı yenileyip dashboard'a yönlendirecek
        return;
      }
    } catch (error) {
      if (error.message === 'pending_approval') {
        setShowApprovalDialog(true);
      } else {
        // Hata mesajını göster
        if (error.response?.data?.detail) {
          const detail = error.response.data.detail;
          
          // Eğer detail bir array ise (FastAPI validation errors)
          if (Array.isArray(detail)) {
            const errorMessages = detail.map(err => {
              const field = err.loc ? err.loc.join('.') : 'Alan';
              return `${field}: ${err.msg}`;
            });
            setError(errorMessages.join('; '));
          }
          // Eğer detail bir obje ise (ama array değil)
          else if (typeof detail === 'object' && detail !== null) {
            setError(detail.msg || 'Giriş yapılırken bir hata oluştu');
          }
          // Eğer detail bir string ise
          else {
            setError(detail);
          }
        } else if (error.message) {
          setError(error.message);
        } else {
          setError('Giriş yapılırken bir hata oluştu');
        }
      }
    }
  };

  const handleFormSubmit = () => {
    setFormSubmitted(true);
  };

  const handleDialogClose = () => {
    if (!formSubmitted) {
      setError('Lütfen önce formu doldurun ve gönderin.');
      return;
    }
    setShowApprovalDialog(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            TrendAsist'e Giriş Yap
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="E-posta"
              name="email"
              autoComplete="email"
              autoFocus
              value={credentials.email}
              onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Şifre"
              type="password"
              autoComplete="current-password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, color: 'white' }}
            >
              Giriş Yap
            </Button>
            <Button
              fullWidth
              variant="text"
              onClick={() => navigate('/')}
            >
              Ana Sayfaya Dön
            </Button>
          </Box>
        </Paper>
      </Box>

      {/* Onay Bekleyen Kullanıcılar için Dialog */}
      <Dialog
        open={showApprovalDialog}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
      >
        <DialogTitle>
          TrendAsist'e Hoş Geldiniz!
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            TrendAsist'e kayıt olduğunuz için teşekkürler. Üyeliğinizin aktif edilmesi için ekibimizden destek almanız gerekmektedir. 3 Gün ücretsiz deneyebilmek için lütfen formu doldurun.
          </Typography>
          <Button
            data-tally-open="wMV9kA"
            data-tally-layout="modal"
            data-tally-width="400"
            data-tally-auto-close="0"
            data-tally-emoji-text="✅"
            data-tally-emoji-animation="wave"
            data-tally-onclose={() => handleFormSubmit()}
            variant="contained"
            fullWidth
            sx={{ mt: 2, color: 'white' }}
          >
            Formu Doldur
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} disabled={!formSubmitted}>
            {formSubmitted ? 'Kapat' : 'Lütfen Formu Doldurun'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
} 